export const VN_COUNTRY_CODE: string = 'VN';

export enum ProductCode {
  CANCER = 'CANCER',
  SPA = 'SPA',
}

export enum PromotionStatus {
  HAPPENING = 'HAPPENING',
  FINISHED = 'FINISHED',
}

export enum HomeNewsPromotionType {
  PROMOTION = 'PROMOTION',
  NEWS = 'EVENT_NEW',
}

export enum ProductType {
  PRODUCT_SUPPORT = 'PRODUCT_SUPPORT',
  PRODUCT_MAIN = 'PRODUCT_MAIN',
}
export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export const PAGE_SIZE = 10;
export const REPLACE_IDENTIFIER = '*****';

export const CAMPAIGN_CODES = {
  EXISTING_CUSTOMER: "nhieu-nam-gan-bo",
  LOCAL_ACCOUNT: "tai-khoan-dia-phuong"
}

// BEGIN: GA TRACKING ON TO OFF
export const ON_TO_OFF_TRACKING = "On To Off";

export enum ON_TO_OFF_STEP {
  CLICK_PROMOTIONS_TO_EXISTING_CUSTOMERS,
  VIEW_DETAIL,
  CHECKBOX,
  CONFIRM
}

export const ON_TO_OFF = [
  {
    id: [ON_TO_OFF_STEP.CLICK_PROMOTIONS_TO_EXISTING_CUSTOMERS],
    code: "ExCus_Step1",
    name: "Step 1: OnToOff_Click Promotions to existing customers",
  },
  {
    id: [ON_TO_OFF_STEP.VIEW_DETAIL],
    code: "ExCus_Step2",
    name: "Step 2: OnToOff_View Detail",
  },
  {
    id: [ON_TO_OFF_STEP.CHECKBOX],
    code: "ExCus_Step3",
    name: "Step 3: OnToOff_Checkbox",
  },
  {
    id: [ON_TO_OFF_STEP.CONFIRM],
    code: "ExCus_Step4",
    name: "Step 4: OnToOff_Confirm",
  },
];
// END: GA TRACKING ON TO OFF

// BEGIN: GA TRACKING LOCAL ACCOUNT
export const LOCAL_ACCOUNT_TRACKING = "Local Account";

export enum LOCAL_ACCOUNT_STEP {
  LOCAL_ACCOUNT_CLICK_BANNER,
  LOCAL_ACCOUNT_CLICK,
  LOCAL_ACCOUNT_VIEW_DETAIL,
  LOCAL_ACCOUNT_CHECKBOX,
  LOCAL_ACCOUNT_CONFIRM
}

export const LOCAL_ACCOUNT = [
  {
    id: [LOCAL_ACCOUNT_STEP.LOCAL_ACCOUNT_CLICK_BANNER],
    code: "LocalAcc_Step1.1",
    name: "Step 1.1: Local Account_Click banner",
  },
  {
    id: [LOCAL_ACCOUNT_STEP.LOCAL_ACCOUNT_CLICK],
    code: "LocalAcc_Step1.2",
    name: "Step 1.2: Local Account_Click Local account",
  },
  {
    id: [LOCAL_ACCOUNT_STEP.LOCAL_ACCOUNT_VIEW_DETAIL],
    code: "LocalAcc_Step2",
    name: "Step 2: Local Account_View Detail",
  },
  {
    id: [LOCAL_ACCOUNT_STEP.LOCAL_ACCOUNT_CHECKBOX],
    code: "LocalAcc_Step3",
    name: "Step 3: Local Account_Checkbox",
  },
  {
    id: [LOCAL_ACCOUNT_STEP.LOCAL_ACCOUNT_CONFIRM],
    code: "LocalAcc_Step4",
    name: "Step 4: Local Account_Confirm",
  }
];
// END: GA TRACKING LOCAL ACCOUNT

export const BUYING_PROCESS_TRACKING = "Buying Process";

export enum BUYING_PROCESS_STEP {
  ClickBuyInsurance,
  InputCustomerInfo,
  ChoicePackageInsurance,
  AnswerHealthQuestion_No,
  AnswerHealthQuestion_Yes,
  ConfirmContactInfo,
  CommitTermOfUse,
  ConfirmPayment,
}

export const BUYING_PROCESS = [
  {
    id: [BUYING_PROCESS_STEP.ClickBuyInsurance],
    name: "Step 1: Click By Insurance",
  },
  {
    id: [BUYING_PROCESS_STEP.InputCustomerInfo],
    name: "Step 2: Input Customer Info",
  },
  {
    id: [BUYING_PROCESS_STEP.ChoicePackageInsurance],
    name: "Step 3: Choice Package Insurance",
  },
  {
    id: [BUYING_PROCESS_STEP.AnswerHealthQuestion_No],
    name: "Step 4: Answer Health Question No",
  },
  {
    id: [BUYING_PROCESS_STEP.AnswerHealthQuestion_Yes],
    name: "Step 4: Answer Health Question Yes",
  },
  {
    id: [BUYING_PROCESS_STEP.ConfirmContactInfo],
    name: "Step 5: Confirm Contact Info",
  },
  {
    id: [BUYING_PROCESS_STEP.CommitTermOfUse],
    name: "Step 6: Commit Term Of Use"
  },
  {
    id: [BUYING_PROCESS_STEP.ConfirmPayment],
    name: "Step 7: Confirm Payment",
  },
];

export enum RequestType {
  FREE_LOOK = "01",
  AFTER_FREE_LOOK = "02"
}

export enum PolicyStatus {
  Active = "001",
  Lapsed = "004",
}

export enum FunctionCode {
  NOT_PERMISSION = '00',
  PAYMENT = '01',
  CHANGE = '04',
  CANCEL = '02',
  TOPUP = '03',
}

export enum PaymentType {
  PAYMENT = 'Payment',
  TOPUP_PAYMENT = 'TopUp_Payment',
  PERIODIC_PAYMENT = 'Periodic_Payment'
}

export const PATH = {
  MY_POLICY: '/my-policy',
  PAYMENT: '/policy/payment',
  PERIODIC_PAYMENT: '/policy/periodic-payment',
  TOPUP_PAYMENT: '/policy/topup-payment',
  POLICY_SEARCH: '/policy/search',
  ONLINE_PAYMENT: '/online-payment',
  CANCEL_POLICY: '/policy/cancel',
  COMPLETE_CANCEL_POLICY: '/policy/complete-cancel',
  OTP_CANCEL_POLICY: '/policy/cancel/otp',
  SPECIAL_OFFERS: '/special-offers',
  SPECIAL_OFFERS_CAMPAIGN: '/special-offers/tai-khoan-dia-phuong',
  PAYMENT_ONLINE: '/payment-online',
  REGISTER_AUTO_PAYMENT: '/payment-online/register-payment',
  DETAIL_AUTO_PAYMENT: '/payment-online/detail-auto-payment',
  CANCEL_REGISTER: '/payment-online/cancel-register',
  CONFIRM_REGISTER_AUTO_PAYMENT:"/payment-online/confirm-register"
}

export const CONSTANT = {
  ID_CARD_TYPE_DEFAULT: 'ALL',
  ID_CARD_NO_DEFAULT: '',
  CIF_DEFAULT: '',
  DOB_DEFAULT: ''
}

export const OTP_LENGTH: number = 6;
export const OTP_TIME = 60; // seconds;
export const OTP_TYPES = {
  CANCEL_POLICY: "CANCEL_POLICY"
}
export const REGEX_BANK_ACCOUNT = /^[0-9\b]+$/;

export const SPECIAL_OFFERS_DETAIL_URL = "https://digital.mbageas.life/cham-lien-tay"

export const SPECIAL_OFFERS_LOCAL_ACCOUNT_DETAIL_URL = 'https://digital.mbageas.life/tai-khoan-dia-phuong'

export const URL_PARAMS = {
  POLICY_NUMBER: "policy_number",
  RM_CODE: "rm_code",
}

export const REGEX_FORMAT = {
  NON_NUMBER: /[^0-9]/g
}

export const ON_TO_OFF_ACTION_TYPE = "ON_TO_OFF";
export const VALIDATE_RM_CODE = /^(?:[^~!@#$%^&*( ).]{0,10}|)$/;
export const FORMAT_DATE_YYYY_MM_DD = "YYYY-MM-DD"
